export enum MortgageProduct {
  budget = 'budget',
  house = 'woning'
}
